<template>
  <table-server :columns="table.columns" :options="tableOptions" :url="urlPermissions" ref="table">
      <div class="table-actions" slot="actions" slot-scope="props">
          <menu-edit :id="props.row.id" :name="props.row.name" :options="menuOptions"
                     @remove="remove(props.row.id)"/>
      </div>
  </table-server>
</template>

<script>
  import { API } from './../../api'
  import TableServer from './../../components/TableServer'
  import MenuEdit from './../../components/MenuEdit'

  export default {
    components: {
      'table-server': TableServer,
      'menu-edit': MenuEdit
    },
    data: () => {
      return {
        urlPermissions: '/api/permissions?token=' + window.localStorage.getItem('access_token'),
        table: {
          columns: ['actions', 'id', 'name', 'slug', 'module_name', 'description']
        }
      }
    },
    computed: {
      menuOptions: function () {

        let options = []

        if (this.$can('update', 'permissions')) {
          options.push({
            type: 'edit',
            text: '',
            link: 'permissions/edit/',
            icon: 'dot-circle',
            callback: '',
            type_action: 'link'
          })
        }
        if (this.$can('delete', 'permissions')) {
          options.push({
            type: 'delete',
            text: '',
            link: '',
            icon: 'trash',
            type_action: 'button',
            callback_delete: 'remove'
          })
        }
        return options
      },
      tableOptions: function () {
        return {
          headings: {
            id: 'ID',
            name: this.$i18n.t('global.name'),
            slug: 'Slug',
            module_name: 'Módulo',
            description: this.$i18n.t('permissions.description'),
            actions: this.$i18n.t('global.table.actions')
          },
          sortable: ['id', 'name', 'slug', 'module_name', 'description'],
          filterable: ['id', 'name', 'slug', 'module_name', 'description'],
          orderBy: {
            column: 'id',
            ascending: false
          }
        }
      }
    },
    methods: {
      onUpdate () {
        this.$refs.table.$refs.tableserver.refresh()
      },
      remove (id) {
        API({
          method: 'DELETE',
          url: 'permissions/' + id
        })
          .then((result) => {
            if (result.data.success === true) {
              this.onUpdate()
            } else {
              this.$notify({
                group: 'main',
                type: 'error',
                title: 'Permisos',
                text: result.data.message
              })
            }
          })
      }
    }
  }
</script>

<style lang="stylus">
    .table-actions
        display flex
</style>
